import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
    useTheme,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Box} from '@mui/system';
import {useTranslation} from 'next-i18next';
import {FaqCategory} from '../../types/models/FaqCategory';
import {Faq} from '../../types/models/Faq';
import {Colors} from '../common/colors';
import {getLocaleLabels} from '../../utils/lang';

type CategoryProps = {
    category: FaqCategory;
};

export default function Category(props: CategoryProps) {
    const {i18n, t} = useTranslation('common');
    const theme = useTheme();
    const isDark = theme.palette.mode == 'dark';

    const locale = getLocaleLabels(props.category.labels, i18n.language);

    return (
        <Accordion
            key={props.category.faq_category_id}
            sx={{
                border: '1px solid ' + Colors.light,
                backgroundColor: isDark ? Colors.dark : 'transparent',
                borderRadius: '8px',
                boxShadow: 0,
                maxWidth: '853px',
                marginLeft: 'auto',
                marginRight: 'auto',
                marginTop: '40px',
                '&:first-of-type': {
                    borderRadius: '8px',
                },
                '&.Mui-expanded': {
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: '40px',
                },
                '&.Mui-expanded:first-of-type': {
                    marginTop: '40px',
                },
                '&:before': {
                    content: 'none',
                },
            }}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                sx={
                    {
                        // backgroundColor: isDark ? Colors.dark : 'transparent',
                    }
                }
            >
                {/* <Box
                    display="flex"
                    flex="1"
                    flexDirection="row"
                    justifyContent="space-between"
                    paddingRight="50px"
                > */}
                <Box>
                    <Typography fontWeight="bold">{locale.label}</Typography>
                    <Typography>{locale.description}</Typography>
                </Box>
                {/* <Typography>
                        ({props.category.faqs.length} {t('word.element')})
                    </Typography> */}
                {/* </Box> */}
            </AccordionSummary>
            <AccordionDetails>
                {props.category.faqs.map((f) => (
                    <QuestionAnswer faq={f} key={f.faq_id} />
                ))}
            </AccordionDetails>
        </Accordion>
    );
}

type QuestionAnswerProps = {
    faq: Faq;
};

function QuestionAnswer(props: QuestionAnswerProps) {
    const {i18n} = useTranslation('common');
    const locale = getLocaleLabels(props.faq.labels, i18n.language);

    return (
        <Box key={props.faq.faq_id}>
            <Typography fontWeight="bold">{locale.question}</Typography>
            <Typography>{locale.answer}</Typography>
        </Box>
    );
}
